import React, { useEffect } from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import styles from "./styles.scss";
import {
  getCriteria,
  getSampleDocuments
} from "Portal/NewPortal/Sections/Home/Cards/Tasks/FlyOver/selectors";

import File from "./File";
import FileUpload from "./FileUpload";
import {
  actions,
  getters
} from "Portal/NewPortal/Sections/Home/Cards/Tasks/FlyOver/model";

import Loading from "ui-kit/Loading";

import { getBackgroundColor } from "Portal/NewPortal/PortalHome/selectors";
import NavigationFullscreen from "material-ui/svg-icons/navigation/fullscreen";

const decorate = R.compose(
  connect(
    state => ({
      loading: getters.loadingFileUpload(state),
      criteria: getCriteria(state),
      sampleDocuments: getSampleDocuments(state),
      backgroundColor: getBackgroundColor(state),
      fileUploadUploadHasFinished: getters.fileUploadUploadHasFinished(state)
    }),
    {
      initFileUpload: actions.initFileUpload,
      onFileSelected: actions.onFileSelected,
      onFileUploadProgress: actions.onFileUploadProgress,
      onFileUploadCancel: actions.onFileUploadCancel,
      onFileUploadFailed: actions.onFileUploadFailed,
      onFileUploadFinished: actions.onFileUploadFinished
    }
  )
);

const FileRequest = ({
  criteria = undefined,
  sampleDocuments = [],
  initFileUpload,
  onFileSelected,
  onFileUploadProgress,
  onFileUploadCancel,
  onFileUploadFailed,
  onFileUploadFinished,
  loading = true,
  backgroundColor = NavigationFullscreen,
  fileUploadUploadHasFinished = true,
  isClosed = false
}) => {
  useEffect(() => {
    if (fileUploadUploadHasFinished) {
      initFileUpload({
        onFileUploadProgress,
        onFileUploadCancel,
        onFileUploadFailed,
        onFileUploadFinished,
        onFileSelected
      });
    }
  }, [fileUploadUploadHasFinished]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        width: "100%"
      }}
    >
      {loading && <Loading />}
      {!loading && (
        <div
          className={styles.container}
          style={{ ...(backgroundColor ? { backgroundColor } : {}) }}
        >
          {criteria && (
            <div className={styles.criteriaSection}>
              <div className={styles.criteriaTitle}>criteria</div>
              <div
                className={styles.criteriaText}
                dangerouslySetInnerHTML={{ __html: criteria }}
              ></div>
            </div>
          )}
          {sampleDocuments && R.length(sampleDocuments) > 0 && (
            <div className={styles.documentSection}>
              <div className={styles.documentTitle}>Sample document</div>
              <div
                className={styles.documentContainer}
                style={{ ...(backgroundColor ? { backgroundColor } : {}) }}
              >
                {sampleDocuments.map(document => (
                  <div className={styles.documentItem}>
                    <File
                      key={document.id}
                      isClickable
                      onClick={() => window.open(document.url, "_blank")}
                      {...document}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
      <FileUpload isClosed={isClosed} />
    </div>
  );
};

export default decorate(FileRequest);
